module.exports = __webpack_public_path__ + "static/img/prize5.b9f51b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/prize5.png
// module id = PPzd
// module chunks = 1